module.exports = __webpack_public_path__ + "img/login_left.fce8645f.png";